/*
 * @Description: 主入口文件
 * @Author: ligy
 * @Date: 2022-02-15 16:06:17
 * @LastEditTime: 2022-03-18 14:41:38
 */
import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import store from './store'
import axios from './config/axios-config.js'
import VueAxios from 'vue-axios'
import GlobalData from './util/GlobalData'
Vue.use(VueAxios, axios)
Vue.use(Vant)
// 引入全局的样式
import '@/styles/index.css'

Vue.config.productionTip = false
Vue.prototype.$globalData = GlobalData
Vue.config.devtools = true
// 1rem = 10px

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
